export const dashboard = {
  chat: {
    title: "Chat",
    description:
      "Accedé a nuestro playground de Chat para probar una variedad de modelos de LLMs.",
    button: "Chat Básico",
    button2: "Chat Comparativo",
    chatInterface: "Interfaz de Chat",
    basicChat: "Chat Básico",
    compareChat: "Chat Comparativo",
  },
  credits: {
    title: "Finanzas y Uso",
    description: "Gestioná tus compras de créditos.",
    addCredits: "Agregar Saldo",
    viewPayments: "Ver Pagos",
    viewUsage: "Detalles de Uso",
  },
  character: {
    title: "Personajes",
    description:
      "Creá y personalizá personajes de IA para interacciones especializadas.",
    newCharacter: "Nuevo Personaje",
    viewCharacters: "Ver Personajes",
  },
  agent: {
    title: "Agentes",
    description:
      "Configurá e implementá agentes de IA para tareas y flujos de trabajo personalizados.",
    viewAgents: "Ver Agentes",
    newAgent: "Nuevo Agente",
  },
  users: {
    title: "Usuarios",
    description:
      "Gestioná cuentas de sub-usuarios, que pueden usar tus Agentes.",
    viewUsers: "Ver Usuarios",
    newUser: "Nuevo Usuario",
  },
  settings: {
    title: "Configuraciones y Cuenta",
    description:
      "Gestioná tus configuraciones de cuenta, perfil, clave de API.",
    settings: "Configuraciones",
    profile: "Perfil",
    affiliate: "Programa de Afiliados",
  },
  community: {
    title: "Comunidad",
    description:
      "Solicitá funcionalidades o charlá sobre temas nerd en Discord.",
    viewFeatures: "Tablero de Funcionalidades", // Or "Panel de Funcionalidades"
    viewDiscord: "Discord",
  },
  support: {
    title: "Soporte",
    description: "Solicitá soporte o ponete en contacto con nosotros.",
    viewSupport: "Atención al Cliente",
    viewContact: "Contacto",
  },
};
